import { message } from 'antd';
import jwtDecode from 'jwt-decode';
import { useCallback, useContext, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import UserContext from './context/user-context';
import applyRefreshTokenInterceptor from './interceptors/refresh_token';
import { instanceRef } from './utils/axios';

const WithAxios = ({ children }) => {
  const history = useHistory();
  const { updateAccessToken, updateUser, logout, removeAuthInfo } = useContext(
    UserContext
  );
  const updateAuthData = useCallback(
    (responseToken) => {
      if (responseToken?.data?.data) {
        const { AuthenticationResult, usuarioSegu } = responseToken.data.data;
        const { AccessToken, IdToken } = AuthenticationResult;
        updateAccessToken(AccessToken);
        const usuario = jwtDecode(IdToken);
        usuario.usuarioSegu = usuarioSegu;
        updateUser(usuario);
      }
    },
    [updateAccessToken, updateUser]
  );

  const onRefreshFail = useCallback(() => {
    logout();
    message.info('La sesión ha expirado');
    history.push('/login');
  }, [logout, history]);

  useMemo(() => {
    applyRefreshTokenInterceptor(instanceRef, updateAuthData, onRefreshFail);
  }, [onRefreshFail, updateAuthData]);

  useEffect(() => {
    window.addEventListener('storage', (e) => {
      if (e.key === 'user') {
        if (e.newValue === null || e.newValue === 'null') {
          removeAuthInfo();
          message.info('Ha cerrado la sesión en otra pestaña');
          history.push('/login');
        } else {
          // updateAuthInfo(JSON.parse(e.newValue));
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return children;
};

export default WithAxios;
